export default [
    {
    path: '/pt-session-rate/:id/',
    name: 'pt-session-rate',
    component: () => import('@/views/pages/pt_session_rate.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
]